import makeStyles from "@mui/styles/makeStyles";
import React, { useState } from "react";
import HoverableButton from "../layout/HoverableButton";
import EditIcon from "@mui/icons-material/Edit";
import EditSessionTypesModal from "components/modals/EditSessionTypesModal";

const useStyles = makeStyles(theme => ({
    root: {
        color: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.secondary.main
        }
    }
}));

/**
 * Cella del valore del filtro "Sessione" (uno o più tipi di leg).
 * params.value è il testo già mappato in nomi, il valore da modificare è params.row.filterValue.
 */
export default function RenderCellSessionTypes({ params, saveEdit, infoMessage, warningMessage }) {

    const classes = useStyles();
    const [modal, setModal] = useState(false);

    if (!saveEdit) return params.value ?? "-"

    return <div>
        <HoverableButton
            item={{
                icon: <EditIcon />,
                name: params.value || "-"
            }}
            onClick={() => setModal(true)}
            classes={{ root: classes.root }}
        />
        <EditSessionTypesModal open={modal} onClose={() => setModal(false)}
            defaultValue={params.row.filterValue}
            onSubmit={newValue => saveEdit(params.row.id, params.field, newValue)}
            infoMessage={infoMessage} warningMessage={warningMessage} />
    </div>
}
